import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function PricingCTA() {
  return <section id="precio" className="py-16 px-6 max-w-3xl mx-auto" data-id="element-70">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-[#E8DDD0]" data-id="element-71">
        <div className="bg-[#2A6B6B] p-4 text-center" data-id="element-72">
          <p className="text-[#FDF8F0] font-medium tracking-wide text-sm uppercase" data-id="element-73">
            Oferta Especial
          </p>
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-74">
          {/* Price showcase */}
          <div className="relative mb-10" data-id="element-75">
            {/* Decorative glow behind price */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-76">
              <div className="w-48 h-48 bg-[#D4654A]/10 rounded-full blur-3xl" data-id="element-77" />
            </div>

            <div className="relative bg-gradient-to-b from-[#FDF8F0] to-[#F5EDE3] rounded-2xl p-8 border border-[#E8DDD0]" data-id="element-78">
              {/* Discount ribbon */}
              <motion.div initial={{
              scale: 0,
              rotate: -12
            }} whileInView={{
              scale: 1,
              rotate: -6
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3,
              type: 'spring',
              stiffness: 200
            }} className="absolute -top-4 -right-2 md:-right-4 bg-[#D4654A] text-white font-bold text-lg px-4 py-2 rounded-xl shadow-lg" data-id="element-79">
                <span className="flex items-center gap-1" data-id="element-80">
                  <Sparkles className="h-4 w-4" data-id="element-81" />
                  -78%
                </span>
              </motion.div>

              {/* Original price */}
              <p className="text-lg text-[#9CA3AF] line-through mb-1" data-id="element-82">
                Precio regular: $29
              </p>

              {/* Current price */}
              <div className="flex items-baseline justify-center gap-1 mb-3" data-id="element-83">
                <span className="text-2xl font-serif text-[#5C544E]" data-id="element-84">
                  Hoy solo
                </span>
                <motion.span initial={{
                scale: 0.8
              }} whileInView={{
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2,
                type: 'spring',
                stiffness: 150
              }} className="text-6xl md:text-7xl font-serif font-bold text-[#D4654A]" data-id="element-85">
                  $6.39
                </motion.span>
              </div>

              {/* Savings callout */}
              <div className="inline-flex items-center gap-2 bg-[#8BAA8B]/15 text-[#2A6B6B] font-semibold text-base px-5 py-2 rounded-full border border-[#8BAA8B]/30" data-id="element-86">
                <span className="w-2 h-2 bg-[#8BAA8B] rounded-full animate-pulse" data-id="element-87" />
                Ahorras $22.61
              </div>

              <p className="text-[#5C544E] text-sm mt-4" data-id="element-88">
                Pago único • Acceso inmediato • Sin suscripción
              </p>
            </div>
          </div>

          <div className="bg-[#FDF8F0] inline-block px-4 py-2 rounded-full text-[#2A6B6B] font-medium text-sm mb-8 border border-[#E8DDD0]" data-id="element-89">
            Garantía: 7 días de satisfacción
          </div>

          <p className="text-lg md:text-xl font-serif text-[#3D3631] mb-4 leading-relaxed" data-id="element-90">
            Si quieres dejar de moverte «con cuidado» y volver a moverte con
            confianza, empieza hoy.
          </p>

          <p className="font-bold text-lg mb-8 text-[#5C544E]" data-id="element-91">
            Descarga «Estabilidad y Equilibrio en Casa (65+)» y sigue el Día 1.
          </p>

          <a href="https://vitalidadpractica.com/cart/51365587550525:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-[#D4654A] hover:bg-[#C0563D] hover:scale-105 transition-all duration-300 text-white text-xl font-bold py-5 px-10 rounded-xl shadow-lg flex items-center justify-center mx-auto group" data-id="element-92">
            <span data-id="element-93">QUIERO MI PLAN DE 30 DÍAS</span>
            <ArrowRight className="ml-3 h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-94" />
          </a>

          <p className="mt-6 text-sm text-[#9CA3AF]" data-id="element-95">
            Pago seguro y encriptado. Recibes el PDF inmediatamente en tu
            correo.
          </p>
        </div>
      </motion.div>
    </section>;
}